(function () {
  function hasExistingFAQPageSchema() {
    const scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (const s of scripts) {
      try {
        const data = JSON.parse(s.textContent);
        // Handle both a single object and an array of schema objects
        const items = Array.isArray(data) ? data : [data];
        if (items.some((item) => item && item["@type"] === "FAQPage")) {
          return true;
        }
      } catch (e) {
        // Ignore malformed JSON-LD blocks, they aren't ours to worry about
      }
    }
    return false;
  }

  function addFAQSchema() {
    if (!window.location.pathname.startsWith("/blogs/")) return;

    // Don't add if this script already ran on this page load
    if (document.querySelector('script[data-auto-faq-schema]')) return;

    // Don't add if the post already ships its own hardcoded FAQPage schema
    if (hasExistingFAQPageSchema()) return;

    const blog = document.querySelector(".pmp-blog");
    if (!blog) return;

    const faqs = blog.querySelectorAll("details");
    if (!faqs.length) return;

    const mainEntity = [];

    faqs.forEach((faq) => {
      const question = faq.querySelector("summary")?.textContent.trim();
      const answer = faq.querySelector("p")?.textContent.trim();

      if (question && answer) {
        mainEntity.push({
          "@type": "Question",
          "name": question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": answer
          }
        });
      }
    });

    if (!mainEntity.length) return;

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-auto-faq-schema", "true");
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": mainEntity
    });

    document.head.appendChild(script);

    console.log("FAQ Schema Added");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", addFAQSchema);
  } else {
    addFAQSchema();
  }
})();